// A surfaced note carries the type and id of the record it was written on. The
// route map mirrors the app routes and LogItem's modelMap so the note card can
// link back to the source without duplicating that knowledge.
const NOTE_SOURCE_ROUTES = {
  Entity: "entities",
  Contact: "contacts",
  Case: "cases",
  RevenueOpportunity: "revenue_opportunities",
};

const noteSourcePath = (modelType, modelId) => {
  const route = NOTE_SOURCE_ROUTES[modelType];
  return route ? `/${route}/${modelId}` : null;
};

export { NOTE_SOURCE_ROUTES, noteSourcePath };
